var config = {
  // api_url : 'https://api.betterspaces.com/admin/v1/'
  // api_url : 'https://api-staging.betterspaces.com/admin/v1/'
  api_url: 'http://localhost:3001/admin/v1/',
  web_url: 'http://localhost:3002/'
  // api_url : 'http://52.204.90.38:3001/admin/v1/'
}

var env = "production"

console.log('REACT_APP_ENV: ' + process.env.REACT_APP_ENV)
console.log('LOADING CONFIG FOR ENV: ' + env)

switch (env) {
  case 'jenkins':
  case 'development':
    config.api_url = 'http://localhost:3001/admin/v1/'
    config.web_url = 'http://localhost:3002/'
  case 'test':
    break
  case 'staging':
    config.raygun_api_key = 'rGYKiz+ttlZws13PricH2Q=='
    config.api_url = 'https://api-staging.betterspaces.com/admin/v1/'
    config.web_url = 'http://staging-web.betterspaces.com/'
    break
  case 'production':
    config.raygun_api_key = 'r2RglGSxoN/tiIwVciY/Mg=='
    config.api_url = 'https://api.betterspaces.com/admin/v1/'
    config.web_url = 'http://web.betterspaces.com/'
    break
  default:
    break
}

export default config



// WEBPACK FOOTER //
// ./src/config.js